module.exports = __webpack_public_path__ + "img/viphead.12110e7a.png";